import React from 'react'

import Image from 'next/image'

import { AppearingWrapper, SectionContainer } from 'Components/Blocks'
import { SubsectionTitle } from 'Components/Blocks/Titles'
import { Column, Row } from 'Components/UI'
import { AppStoreLink, GooglePlayLink } from 'Components/UI/AppLink'

import { AppMockupImage } from 'Assets/Images/Sections/GetAppSection'

import { LANDING_CONTENT_PX } from 'Constants/Landing'

import { useResponsiveLayout } from 'Hooks'

import { Container, ImageHolder } from './styles'

function GetAppSection() {
  const { isMobile } = useResponsiveLayout()

  return (
    <SectionContainer>
      <AppearingWrapper centered>
        <Container
          flexDirection={isMobile ? 'column' : 'row'}
          px={LANDING_CONTENT_PX}
          py={[40, 40, 80, 100]}
        >
          <Column
            alignCenter={isMobile}
            alignEnd={!isMobile}
            fullHeight
            justifyCenter={isMobile}
            width={[1, 1, 1, 1 / 2]}
          >
            <ImageHolder>
              <Image alt="" src={AppMockupImage} />
            </ImageHolder>
          </Column>

          <Column alignCenter={isMobile} gap={8} width={[1, 1, 1, 1 / 2]}>
            <SubsectionTitle
              centered={isMobile}
              paragraph={
                <>
                  As an Emajin Golf Member, you have exclusive access to our
                  Emajin Golf App.
                  <br />
                  <br />
                  From the convenience of your phone, you can register for
                  events, research all of our Golf Club venue partners, reach
                  out to business professionals and connect with industry
                  leaders across Australia.
                  <br />
                  <br />
                  Download now from the Apple App Store or Google Play, enter
                  your membership details and start connecting to do better
                  business today.
                </>
              }
              subtitle="Download. Connect. Network."
              title="Get the App"
            />

            <Row gap={5}>
              <AppStoreLink />

              <GooglePlayLink />
            </Row>
          </Column>
        </Container>
      </AppearingWrapper>
    </SectionContainer>
  )
}

export default GetAppSection
